import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Immediate cleanup of legacy token stored in localStorage from previous app versions
try {
  if (typeof window !== 'undefined' && window.localStorage) {
    const raw = localStorage.getItem('iresource-auth');
    if (raw && raw.includes('"token"')) {
      const parsed = JSON.parse(raw);
      if (parsed?.state?.token) {
        delete parsed.state.token;
        localStorage.setItem('iresource-auth', JSON.stringify(parsed));
      }
    }
    // Also clean up obsolete test keys if present
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
  }
} catch (_) {}

const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null, // { sub, email, roles, du_assigned, name }
      isAuthenticated: false,
      setAuth: (token, user) => set({ token, user, isAuthenticated: true }),
      clearAuth: () => {
        try {
          localStorage.removeItem('iresource-auth');
        } catch (_) {}
        set({ token: null, user: null, isAuthenticated: false });
      },
    }),
    {
      name: 'iresource-auth',
      // SECURITY: Never persist raw JWT in localStorage. Only persist safe display user info.
      partialize: (state) => ({ user: state.user }),
    }
  )
);

export default useAuthStore;
